import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconTextBeta = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M11.745 11.777c0.703-0.566 1.131-1.371 1.131-2.4 0-2.006-1.629-3.377-3.652-3.377h-4.731v12h5.091c2.074 0 3.737-1.423 3.737-3.48 0-1.251-0.617-2.194-1.577-2.743zM9.225 8.211c0.754 0 1.286 0.566 1.286 1.32s-0.549 1.32-1.286 1.32h-2.366v-2.64h2.366zM9.585 15.789h-2.726v-2.829h2.726c0.806 0 1.389 0.6 1.389 1.406 0 0.823-0.583 1.423-1.389 1.423z M17.238 15.737v-2.691h4.543v-2.229h-4.543v-2.554h4.971v-2.263h-7.337v12h7.423v-2.263h-5.057z M31.9 6h-8.829v2.263h3.223v9.737h2.366v-9.737h3.24v-2.263z M40.935 18h2.571l-4.217-12h-2.931l-4.2 12h2.554l0.72-2.16h4.783l0.72 2.16zM36.187 13.629l1.646-4.903 1.646 4.903h-3.291z" }),
    width: 48,
});

export { IconTextBeta };
